<template>
  <div></div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    }),
  },
  methods: {
    async storeToken() {
      await axios.post(this.userRoute + "/integrations/quickbooks", {
        code: this.$route.query.code,
        realmId: this.$route.query.realmId,
        state: this.$route.query.state
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Authorization with QuickBooks Successful',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          window.parent.location.reload();
        });
      })
      .catch(error => {
        // 
      });
    }
  },
  created() {
    this.storeToken();
    document.body.classList.add('quickbooks-authorize');
  }
};
</script>
<style lang="scss">
#hubspot-messages-iframe-container {
  display: none !important;
}
.quickbooks-authorize .wrapper {
  display: none;
}
.quickbooks-authorize .footer {
  display: none;
}
</style>